import { ALLOWED_ATTACHMENT_TYPES } from './types';
const MAX_IMAGE_DIMENSION = 2048;
const WEBP_QUALITY = 0.85;
const loadImage = async (file) => new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
        URL.revokeObjectURL(img.src);
        resolve(img);
    };
    img.onerror = () => {
        URL.revokeObjectURL(img.src);
        reject(new Error(`Failed to load image: ${file.name}`));
    };
    img.src = URL.createObjectURL(file);
});
const calculateResizedDimensions = (width, height, maxDimension) => {
    if (width <= maxDimension && height <= maxDimension) {
        return { width, height };
    }
    const scale = maxDimension / Math.max(width, height);
    return {
        width: Math.round(width * scale),
        height: Math.round(height * scale),
    };
};
const canvasToWebPBase64 = (canvas, quality) => {
    const dataUrl = canvas.toDataURL('image/webp', quality);
    return dataUrl.replace(/^data:image\/webp;base64,/, '');
};
const generateWebPFilename = (originalFilename) => {
    const lastDot = originalFilename.lastIndexOf('.');
    const baseName = lastDot > 0 ? originalFilename.substring(0, lastDot) : originalFilename;
    return `${baseName}.webp`;
};
export const processImage = async (file, maxDimension = MAX_IMAGE_DIMENSION, quality = WEBP_QUALITY) => {
    const img = await loadImage(file);
    const size = calculateResizedDimensions(img.naturalWidth, img.naturalHeight, maxDimension);
    const canvas = document.createElement('canvas');
    canvas.width = size.width;
    canvas.height = size.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        console.error('Failed to get canvas 2D context');
        throw new Error('Failed to get canvas 2D context');
    }
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, size.width, size.height);
    const data = canvasToWebPBase64(canvas, quality);
    return {
        data,
        filename: generateWebPFilename(file.name),
        width: size.width,
        height: size.height,
        size: Math.round((data.length * 3) / 4),
    };
};
export const isValidImageFile = (file) => ALLOWED_ATTACHMENT_TYPES.image.includes(file.type);
//# sourceMappingURL=image-utils.js.map